module.exports = __webpack_public_path__ + "img/93.fd9ca2ff.jpg";